import * as React from 'react'

import { Box, Tag, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const IncidentShiftLocation = ({ count }: { count: number }) => {
  const [open, toggle] = useToggle()

  return (
    <Tooltip.ItemList
      attachment="bottom center"
      targetAttachment="top center"
      open={open}
      toggle={toggle}
    >
      <Box paddingY="s12">
        <Tag leftItem="icon" type="champagne" icon="pin">
          {i18n.tp('time_tracking.table.body.issues', {
            count: count,
          })}
        </Tag>
      </Box>
      <Box gap="s8" textAlign="center" background="grey800" alignItems="center">
        <Text.Header3>{i18n.t('time_tracking.table.body.issues_tooltip.header')}</Text.Header3>
        <Text.Normal>{i18n.t('time_tracking.table.body.issues_tooltip.description')}</Text.Normal>
      </Box>
    </Tooltip.ItemList>
  )
}

export default IncidentShiftLocation
